import { COLOR_PALETTE } from 'constants/ui';

import { AVATAR_SIZE, INITIALS_FONT_SIZE } from './BorrowerCrmAvatar.constants';

const baseAvatarStyles = {
  width: AVATAR_SIZE,
  height: AVATAR_SIZE,
  borderRadius: '50%',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  flex: 'none',
};

export const getLinkedAvatarStyles = backgroundColor => ({
  ...baseAvatarStyles,
  backgroundColor,
  boxShadow: ({ palette }) =>
    `0px 0px 0px 2px ${palette.background.primary}, 0px 0px 0px 3px ${palette.border.default}`,
});

export const initialsStyles = {
  color: COLOR_PALETTE.GRAY[1],
  fontWeight: 600,
  fontSize: INITIALS_FONT_SIZE,
  lineHeight: 1,
};

export const emptyAvatarStyles = {
  ...baseAvatarStyles,
  backgroundColor: ({ palette }) => palette.background.disabled,
  color: ({ palette }) => palette.text.placeholder,
};
